/**
 *
 * Criação do objecto de envio de email.
 * Esta função irá preparar o objecto a ser enviado para API.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const sendEmail = {
        ...( data.requestId && { id: data.requestId }),
        ...( data.email && { destination_email: data.email }),
        ...( data.templateId && { mail_template_id: data.templateId })
    };

    return sendEmail;
};

const requiredFields = [
    { field: 'templateId', isRequiredOnEdit: false },
    { field: 'email', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};